<template>
  <b-row>
    <b-col md="5">
      <heading />
      <b-row class="my-4">
        <b-col sm="4">
          <div class="text-center">
            <div>Aktívne meradlá</div>
            <hr class="my-1" />
            <h4 class="m-0">
              {{ summary.totalMeasurers | formatNumber }}
            </h4>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="text-center">
            <div>Celková spotreba <small>(kWh)</small></div>
            <hr class="my-1" />
            <template v-if="totalVTNT">
              <h4 class="m-0">
                {{ totalVTNT | formatNumber(2) }}
              </h4>
              <div v-if="totalVTNT !== totalMeasured" class="fs-sm">
                {{ totalMeasured | formatNumber(2) }}
                <b-badge class="fs-sm align-top">
                  {{ measuredRate | formatNumber }}%
                </b-badge>
              </div>
            </template>
            <template v-else>
              <b-icon class="text-muted" icon="question-circle" />
            </template>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="text-center">
            <div>Meraná spotreba <small>(kWh)</small></div>
            <b-progress
              style="margin-top: 2px; margin-bottom: 2px"
              :value="consumptionRate"
              height="5px"
              variant="primary"
            />
            <h4 class="m-0">
              {{ selectedMeasurersConsumption | formatNumber(2) }}
              <b-badge v-if="totalVTNT" class="fs-sm align-top">
                {{ consumptionRate | formatNumber }}%
              </b-badge>
            </h4>
          </div>
        </b-col>
      </b-row>
      <chart
        v-if="selectedMeasurers.length"
        :sliced-value="diffTotalMeasured"
        :measurers="selectedMeasurers"
        :selected-total="selectedTotal"
        :summary="summary"
      />
      <p v-else class="fs-lg font-weight-bold text-muted text-center">
        <b-icon icon="info-circle" class="mr-1" />
        Pre grafické znázornenie zvoľte meradlo z tabuľky
        <b-icon icon="arrow-right" class="ml-2" animation="cylon" />
      </p>
      <hr />
      <div class="my-4">
        <footer-block />
      </div>
    </b-col>
    <b-col md="7">
      <transition mode="out-in" name="fadeDownShort">
        <template v-if="view === 'measuring'">
          <measuring
            @selectedRows="onSelectedItems"
            @selectedTotal="onSelectedTotal"
          />
        </template>
        <template v-else-if="view === 'devices'">
          <devices />
        </template>
        <template v-else-if="view === 'history'">
          <history :data="viewData" />
        </template>
      </transition>
    </b-col>
  </b-row>
</template>
<script>
import Heading from '../cards/Heading'
import Chart from '../cards/Chart'
import Devices from './Devices'
import Measuring from './Measuring'
import History from '../cards/History'
import FooterBlock from '../cards/Footer'

export default {
  components: {
    Heading,
    Chart,
    Devices,
    Measuring,
    History,
    FooterBlock,
  },
  props: {
    consumer: {
      type: Object,
      required: true,
    },
    summary: {
      type: Object,
    },
  },
  data() {
    return {
      view: 'measuring',
      viewData: {},
      selectedMeasurers: [],
      selectedTotal: false,
    }
  },
  computed: {
    totalVTNT() {
      let total = this.consumer.amountNT + this.consumer.amountVT
      return total ? total * 1000 : 0
    },
    totalMeasured() {
      return this.totalVTNT
        ? this.totalVTNT - this.selectedMeasurersConsumption
        : 0
    },
    consumptionRate() {
      if (this.totalVTNT) {
        return 100 * (this.selectedMeasurersConsumption / this.totalVTNT)
      }
      return 0
    },
    measuredRate() {
      if (this.totalVTNT !== this.totalMeasured) {
        return 100 * (this.totalMeasured / this.totalVTNT)
      }
      return 0
    },
    selectedMeasurersConsumption() {
      if (this.selectedTotal) {
        return this.summary.totalConsumption
      }
      return this.selectedMeasurers.reduce(
        (accumulator, row) => row.consumption + accumulator,
        0,
      )
    },
    diffTotalMeasured() {
      return this.totalVTNT - this.selectedMeasurersConsumption
    },
  },
  mounted() {
    this.$root.$on('operation.view', this.showTab)
  },
  beforeDestroy() {
    this.$root.$off('operation.view')
  },
  methods: {
    onSelectedItems(items) {
      this.selectedMeasurers = items
    },
    onSelectedTotal(val) {
      this.selectedTotal = val
    },
    showTab({ name, data }) {
      this.view = name
      this.viewData = data
    },
  },
}
</script>
